import { MasterSlot, PerDaySlotsForCustomData, ShopMaxPerDay, TeamMaxPerTime } from '../../shared/models/slot-management.model';
import { days, TransportationType } from "@signal/asp-data-commons";
import { ShopMaxPerTime } from "../../shared/models/slot-management.model";
import { SlotState } from './slot.reducer';

export const getMaxAndMasterSlots = (shopMax: ShopMaxPerDay[],
    teamMax: PerDaySlotsForCustomData[],
    txmTeamMax: ShopMaxPerDay[],
    masterSlot: MasterSlot[],
    props: { view: string }) => {
    let max;
    if (props.view == 'Shop') {
        max = shopMax;
    }
    else if(props.view == 'TXM'){
        max= txmTeamMax;
    } else {
        max = teamMax;
    }
    return { max, masterSlot };
};

export const getTransportMaxAndMasterSlots = (state, props: { view: string}) => {
    let max;
    if (props.view == TransportationType.SHUTTLE) {
        max = state.shuttleMaxTotal.data;
    } else if (props.view == TransportationType.RENTAL) {
        max = state.rentalMaxTotal.data;
    }  else if (props.view == TransportationType.REMOTE) {
        max = state.remoteMaxTotal.data;
    }
    return { max, masterSlot: state.masterSlots.data};
};

export const getTransportMaxSlots = (state : SlotState, props) => {
    let maxSlots = [];
    if (props.view == TransportationType.SHUTTLE) {
        maxSlots = state.shuttleMaxSlots.data?.slotsPerDay;
    } else if (props.view == TransportationType.RENTAL) {
        maxSlots = state.rentalMaxSlots.data?.slotsPerDay;
    } else if (props.view == TransportationType.REMOTE) {
        maxSlots = state.remoteMaxSlots.data?.slotsPerDay;
    }
    return maxSlots;
}

export const getTransportMaxTotal = (state : SlotState, props) => {
    let maxTotal = [];
    if (props.view == TransportationType.SHUTTLE) {
        maxTotal = state.shuttleMaxTotal.data;
    } else if (props.view == TransportationType.RENTAL) {
        maxTotal = state.rentalMaxTotal.data;
    } else if (props.view == TransportationType.REMOTE) {
        maxTotal = state.remoteMaxTotal.data;
    }
    return maxTotal;
}


export const enrichShopMaxSlots = (data: ShopMaxPerTime | TeamMaxPerTime) => {
    if (data.slotsPerDay && data.slotsPerDay.length < 7) {
        days.forEach(day => {
            if (!data.slotsPerDay.map(x => x.dayOfWeek).includes(day)) {
                data.slotsPerDay.push({ dayOfWeek: day, slots: [] });
            }
        });
    }
    return data;
}

export const enrichTeamMaxSlots = (data: TeamMaxPerTime[]): TeamMaxPerTime[] => {
    const result = [];
    data.forEach(team => {
        result.push(enrichShopMaxSlots(team));
    });
    return result;
}

export function setTransportMaxSlots(draftState, payload) {
    if(payload.transport == TransportationType.REMOTE){
        draftState.remoteMaxSlots = {
            data: payload.transportMaxSlots,
            loading: false,
            loaded: true,
            error: '',
            isUpdated:true
        }
    }else if(payload.transport == TransportationType.SHUTTLE){
        draftState.shuttleMaxSlots = {
            data: payload.transportMaxSlots,
            loading: false,
            loaded: true,
            error: '',
            isUpdated:true
        }
    }else if(payload.transport == TransportationType.RENTAL){
        draftState.rentalMaxSlots = {
            data: payload.transportMaxSlots,
            loading: false,
            loaded: true,
            error: '',
            isUpdated:true
        }
    }
}

export function setTransportMaxTotal(draftState, payload) {
    if(payload.transport == TransportationType.REMOTE){
        draftState.remoteMaxTotal = {
            data: payload.transportMaxTotal,
            loading: false,
            loaded: true,
            error: '',
            isUpdated:true
        }
    }else if(payload.transport == TransportationType.SHUTTLE){
        draftState.shuttleMaxTotal = {
            data: payload.transportMaxTotal,
            loading: false,
            loaded: true,
            error: '',
            isUpdated:true
        }
    }else if(payload.transport == TransportationType.RENTAL){
        draftState.rentalMaxTotal = {
            data: payload.transportMaxTotal,
            loading: false,
            loaded: true,
            error: '',
            isUpdated:true
        }
    }
}

export function setTransportMaxSlotsLoading(draftState, payload) {
    if(payload.transport == TransportationType.REMOTE){
        draftState.remoteMaxSlots = {
            data: {} as ShopMaxPerTime,
            loading: true,
            loaded: false,
            error: ''
        }
    }else if(payload.transport == TransportationType.SHUTTLE){
        draftState.shuttleMaxSlots = {
            data: {} as ShopMaxPerTime,
            loading: true,
            loaded: false,
            error: ''
        }
    }else if(payload.transport == TransportationType.RENTAL){
        draftState.rentalMaxSlots = {
            data: {} as ShopMaxPerTime,
            loading: true,
            loaded: false,
            error: ''
        }
    }
}